import { ProgramTypeModel } from '@core/typings/programs.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ProgramsState extends BaseYcState {
  readonly programTypes: ProgramTypeModel[];
}
